import { OperatorStatus } from './control.dao';
import { IEventRequestParams, IPaginationParams } from './shared.dto';
import { IUserDTO } from './user-groups.dao';

abstract class IOperatorsDAO {
    public abstract getOperators(params: IEventRequestParams): Promise<IOperatorsDetailsDTO[]>;
    public abstract getAllOperators(params: IPaginationParams): Promise<IOperatorListDTO>;
}

enum Status {
    NotReady = 'NOT_READY',
    Ready = 'READY'
}

interface IOperatorsDetailsDTO extends IOperatorsDTO {
    status: Status;
}

export enum OperatorRole {
    DRIVER = 'DRIVER',
    RIDER = 'RIDER',
    LIVESTREAM_DRIVER = 'LIVESTREAM_DRIVER',
    MODERATOR = 'MODERATOR',
    SHADOW = 'SHADOW',
    MS_TEAMS_OP = 'MS_TEAMS_OP',
    BRIDGE_OP = 'BRIDGE_OP',
    LIVESTREAM_BACKUP = 'LIVESTREAM_BACKUP'
}

interface IOperatorsDTO {
    firstName: string;
    lastName: string;
    email: string;
    operatorId: number;
    operatorRole?: OperatorRole;
    user?: IUserDTO;
    active?: boolean;
}

interface IUserOperatorDTO extends Omit<IOperatorsDTO, 'operatorId'> {
    fullName?: string;
    operatorStatus?: OperatorStatus;
    user: IUserDTO;
}

interface IOperatorListDTO {
    content: IOperatorsDTO[];
}

export { IOperatorsDAO, IOperatorsDetailsDTO, IOperatorsDTO, IOperatorListDTO, Status, IUserOperatorDTO };
